import { setAutoFreeze } from 'immer'
import { Settings } from 'luxon'
import React from 'react'
import ReactDOM from 'react-dom'

import { Auth0Provider } from './utils/auth'
import App from './App'
import config from './auth_config.json'
import GlobalErrorBoundary, { AuthErrorFallback } from './components/GlobalErrorBoundary'
import '@wemolo/components/style.css'
import Base from './base'
import { initSentry } from './logging'
import history from './utils/history'

setAutoFreeze(false)
initSentry()

// A function that routes the user to the right place
// after login
const onRedirectCallback = (appState?: any) => {
    history.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname)
}

Settings.defaultZone = 'Europe/Berlin'

// Create a portal for modals (in order to support focus trapping).
// See https://www.w3.org/TR/wai-aria-practices-1.1/#dialog_modal for rationale
const portalRoot = document.createElement('div')
portalRoot.id = 'portal-root'
document.body.append(portalRoot)

const renderErrorPage = (logout?: () => void, error?: Error) => <AuthErrorFallback logout={logout} error={error} />

ReactDOM.render(
    <Base>
        <GlobalErrorBoundary>
            <Auth0Provider
                localStorage
                domain={config.domain}
                client_id={config.clientId}
                audience={config.audience}
                redirect_uri={config.redirect_uri}
                //scope="openid profile email"
                onRedirectCallback={onRedirectCallback}
                renderErrorPage={renderErrorPage}
            >
                <React.Suspense fallback="">
                    <App />
                </React.Suspense>
            </Auth0Provider>
        </GlobalErrorBoundary>
    </Base>,
    document.getElementById('root')
)
